import { render, staticRenderFns } from "./ModalBoxLayout.vue?vue&type=template&id=03c4faac&"
import script from "./ModalBoxLayout.vue?vue&type=script&lang=js&"
export * from "./ModalBoxLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalBoxLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports